import React from 'react';
import { ReactSVG } from 'react-svg';
import { getPublicImagePath, useAppState } from '@nutastic/nutastic-react-app';
import Href from './Href';
import classnames from 'classnames';

const componentClass = 'footer';

const Footer = ({ useReducedPadding }) => {
    const { navigation : { footerNavigation } = {} } = useAppState();
    const copyrightYear = new Date().getFullYear();
    const classes = classnames(componentClass, {
        [`${componentClass}--reducePadding`]: useReducedPadding
    })

    return <footer className={classes}>
        <div className="container">
            <ReactSVG src={getPublicImagePath('logo--emblem.svg')} className="footer__logo" />
            <div className="footer__nav">
                {
                    Object.values(footerNavigation || {}).map((n, i) => {
                        const { href, title, new_window, slug } = n;
                        const openInNewWindow = !!parseInt(new_window);
                        const Tag = openInNewWindow ? 'a' : Href;
                        return <Tag
                            key={i}
                            url={`/${slug}`}
                            href={href}
                            target={ openInNewWindow ? '_blank' : '_self'}
                            rel="noreferrer">{ title }
                        </Tag>;
                    })
                }
            </div>
            <div className={`${componentClass}__copyright`}>
                <span>The NuStation • @NutasticDotNet &copy; { copyrightYear } • All Rights Reserved</span>
            </div>
        </div>
    </footer>;
};

export default Footer;
